export default __webpack_public_path__ + "static/media/pig-orange.e70f32f2.svg";